import { COMPONENT_EXTENDER } from 'extender'

const SingleContainerLayout = COMPONENT_EXTENDER('components/layouts/SingleContainerLayout')
const BatchPayment = COMPONENT_EXTENDER('components/core/Transactions/TransactionsBatchPayment/components/SelectedPayment')

const BatchPaymentPage = () => (
    <SingleContainerLayout>
        <BatchPayment />
    </SingleContainerLayout>
)

export default BatchPaymentPage
